import { render, staticRenderFns } from "./ReviewEntry.vue?vue&type=template&id=48a85b36&scoped=true&"
import script from "./ReviewEntry.vue?vue&type=script&lang=ts&"
export * from "./ReviewEntry.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewEntry.vue?vue&type=style&index=0&id=48a85b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a85b36",
  null
  
)

export default component.exports